import * as Auth from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { shouldSkipAuth } from "../App";
import { User, UserRole } from "shared/User";

export const useUser = (): Partial<User> => {
  const [user, setUser] = useState<Partial<User>>();
  useEffect(() => {
    if (shouldSkipAuth()) return;
    Promise.all([Auth.fetchAuthSession(), Auth.fetchUserAttributes()]).then(([session, attrs]) => {
      const groups: Array<UserRole> = session.tokens?.accessToken.payload["cognito:groups"] as Array<UserRole>;

      setUser({
        userId: attrs.sub!,
        email: attrs.email!,
        username: attrs.email!,
        groups,
      });
    });
  }, []);
  return user || {};
};
